module.exports = __webpack_public_path__ + "img/other@3x.f0152ad7.png";